import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const ContactInfoTab = ({ 
  contactSettings, 
  setContactSettings, 
  handleContactSubmit, 
  isSubmitting 
}) => {
  return (
    <form onSubmit={handleContactSubmit} className="space-y-6">
      <h3 className="text-lg font-medium text-white">Контактная информация</h3>
      <p className="text-gray-400 text-sm">Обновите контактные данные, которые отображаются на вашем веб-сайте и в подвале.</p>
      
      <div className="space-y-6">
        <div className="flex items-center space-x-3">
          <Mail className="h-5 w-5 text-blue-500" />
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Адрес электронной почты
            </label>
            <input
              type="email"
              value={contactSettings.contact_email}
              onChange={(e) => setContactSettings({...contactSettings, contact_email: e.target.value})}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white placeholder-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="info@fotografx.de"
              required
            />
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <Phone className="h-5 w-5 text-green-500" />
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Номер телефона
            </label>
            <input
              type="tel"
              value={contactSettings.contact_phone}
              onChange={(e) => setContactSettings({...contactSettings, contact_phone: e.target.value})}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white placeholder-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="+49 (0) 123 456 789"
              required
            />
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <MapPin className="h-5 w-5 text-red-500" />
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Адрес
            </label>
            <input
              type="text"
              value={contactSettings.contact_address}
              onChange={(e) => setContactSettings({...contactSettings, contact_address: e.target.value})}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white placeholder-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Berlin, Deutschland"
              required
            />
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <Clock className="h-5 w-5 text-yellow-500" />
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Часы работы
            </label>
            <input
              type="text"
              value={contactSettings.contact_hours}
              onChange={(e) => setContactSettings({...contactSettings, contact_hours: e.target.value})}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white placeholder-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Пн-Пт 09:00-18:00, Сб 10:00-16:00"
              required
            />
          </div>
        </div>
      </div>

      <div className="bg-gray-900 p-4 border border-gray-700 rounded-md">
        <h4 className="text-sm font-medium text-white mb-2">Примечание:</h4>
        <p className="text-xs text-gray-400">
          Эти контактные данные автоматически обновятся в подвале вашего веб-сайта, на странице контактов и в любых других местах, где отображается контактная информация.
        </p>
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50 transition-colors duration-200"
        >
          {isSubmitting ? 'Сохранение...' : 'Сохранить контактную информацию'}
        </button>
      </div>
    </form>
  );
};

export default ContactInfoTab;